import { gql } from "@apollo/client"
import { PROCESS_SCHEDULE_FIELDS } from "./processScheduleFieldsFragment"
import { RESPONSE_SET_FIELDS } from "./responseSetFragment"
import { PROCESS_STEP_FIELDS } from "./processStepFieldsFragment"
import { TAG_FIELDS } from "../../tags/useQueryTags"

const PROCESS_FIELDS = gql`
  fragment ProcessFields on Process {
    id
    type
    name
    tags {
      ...TagFields
    }
    description
    hasScoring
    hasLiveScoring
    hasSubmit
    steps {
      ...ProcessStepFields
    }
    stepCount
    schedules {
      ...ProcessScheduleFields
    }
    sets
    categories {
      id
      name
    }
    users {
      id
      fullName
      firstName
      lastName
      avatar {
        key
      }
      activeAt
    }
    groups {
      id
      name
    }
    author {
      id
      fullName
      firstName
      lastName
      avatar {
        key
      }
      activeAt
    }
    inactive
    locations {
      location {
        id
        name
        subLocations {
          id
          name
        }
      }
      subLocations
    }
    createdAt
    updatedAt
    visibility
    responseSetStyles {
      response
      responseSet
      background
    }
  }
  ${TAG_FIELDS}
  ${RESPONSE_SET_FIELDS}
  ${PROCESS_SCHEDULE_FIELDS}
  ${PROCESS_STEP_FIELDS}
`

export { PROCESS_FIELDS }
